<template>
  <layout-admin-dashboard-view
    :back-route="{ name: 'admin' }"
    :show-toolbar="true">
    <template #title>
      {{ translateTitleCase("entity.crud.entityListTitle") }}
    </template>

    <template #toolbarStart>
      <div class="margin-l-bottom">
        <div class="input-wrapper max-width-200">
          <form-input type="text" v-model="textFilter" placeholder="סינון"></form-input>
        </div>

      </div>
    </template>
    <template #default>
      <spinner v-if="asyncOps.asyncStatus.loading"></spinner>
      <block v-else>
        <card class="">
          <div class="flex flex-wrap gap-l flex-stretch">
            <saffron-link
              class="plain-link"
              v-for="entity of entityList"
              :key="entity.slug"
              v-slot="{ navigate, href, route }"
              :to="{ name: 'admin-entity-entityType', params: { entityType: entity.slug } }"
              custom
              :entity="entity">
              <div
                v-show="shouldShowEntity(entity)"
                class="plain-link cursor-pointer padding-m border-thin-gray-2 bg-gray-1 animate__fadeIn animate--faster"
                :full-width="false"
                :title="entity.namePlural"
                style="min-width: 350px"
                @click="navigate">
                <h3 class="margin-s-bottom">
                  {{ t(entity.namePlural) }}
                </h3>
                <p>{{ safeTranslate(entity.description) }}</p>
              </div>
            </saffron-link>
          </div>
        </card>
      </block>
    </template>
  </layout-admin-dashboard-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import { useStore } from "vuex";

export default {
  name:"AdminEntityDashboard",
  setup: function (props) {
    let { asyncOps, asyncOpsReady } = asyncOperations(props, useStore());

    return { asyncOps, asyncOpsReady };
  },
  data: function () {
    return {
      entityList: {},
      asyncData: {
        // simple version: just route for the data
        entityList: {
          target: "entity",
          data: {},
          options: {
            dataMutator: (data) => {
              let sorted;
              let asArray = Object.values(data);

              try {
                sorted = asArray
                  .sort((a, b) => {
                    let str1 = this.t(a.name);
                    let str2 = this.t(b.name);
                    return str1.localeCompare(str2);
                  })
                  .reduce((acc, obj) => {
                    const key = obj.slug;
                    acc[key] = obj;
                    return acc;
                  }, {});
              } catch (e) {
                console.log(e);
              }


              return sorted;
            },
          },
        },
      },
      textFilter: "",
    };
  },
  computed: {
    entitiesWithEntityApi() {
      let result = {};

      for (const [key, val] of Object.entries(this.entityList)) {
        if (val && val.usesEntityApi) {
          if (this.entityNameMatchesTextFilter(val)) {
            result[key] = val;
          }
        }
      }

      return result;
    },
  },
  methods: {
    entityNameMatchesTextFilter(entity) {
      let translated = this.t(entity.name);
      const filter = this.textFilter.toLowerCase();
      const lowerCaseTranslated = translated.toLowerCase();
      if (lowerCaseTranslated.includes(filter)) {
        return true;
      }

      return entity.name.toLowerCase().includes(filter);
    },
    shouldShowEntity (entity) {
      if (entity?.usesEntityApi) {
        if (this.entityNameMatchesTextFilter(entity)) {
          return true;
        }
      }

      return false;
    },
  },
};
</script>

<style scoped lang="scss">
.entity-link {
  cursor: pointer;
}
</style>
